export class PosRevenueEndpoints {
  getTopCommodity(params: Record<string, string | number | boolean | undefined>): string {
    const entries = Object.entries(params ?? {})
      .filter(([, v]) => v !== undefined && v !== "" && v !== null)
      .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`);
    const qs = entries.join("&");
    return `/hydra/v1/pos-dashboard/revenue/commodity${qs ? `?${qs}` : ""}`;
  }
}